<template>
  <b-container>
    <div v-if="loadError" class="text-danger user-load-error">{{$t('user_load_error')}}
      <b-button class="user-load-retry" type="button" :disabled="isBusy" @click="loadData">{{$t('retry')}}</b-button>
    </div>
    <div v-if="dataLoaded">
      <b-form-group v-for="field in fields" :key="field.id" :label="$t(field.label)" :label-for="field.id">
        <b-form-input :id="field.id" :value="field.value" disabled />
      </b-form-group>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import { REQUEST_TIMEOUT_MS } from "../../utils/RequestGuard";

export default {
  name: "UserInfo",
  data() {
    return { isBusy: true, loadError: false, dataLoaded: false, disposed: false, readVersion: 0, form: {} };
  },
  computed: {
    fields() {
      return [
        { id: 'organisation', label: 'user.create.organisation', value: this.form.company?.name },
        { id: 'company.identity', label: 'user.info.company.identity', value: this.form.company?.identity },
        { id: 'login', label: 'user.create.login', value: this.form.login },
        { id: 'name', label: 'user.create.name', value: this.form.name },
        { id: 'phone', label: 'user.create.phone', value: this.form.phone },
        { id: 'email', label: 'user.create.email', value: this.form.email },
      ];
    },
  },
  methods: {
    async loadData() {
      if (this.disposed) return;
      const request = ++this.readVersion;
      this.isBusy = true; this.loadError = false; this.dataLoaded = false;
      try {
        const response = await axios.get('api/v1/users/info', { timeout: REQUEST_TIMEOUT_MS });
        if (this.disposed || request !== this.readVersion) return;
        if (!response.data || typeof response.data.name !== 'string' || !response.data.company) throw new Error('Invalid profile');
        this.form = response.data; this.dataLoaded = true;
      } catch (error) {
        if (!this.disposed && request === this.readVersion && error.response?.status !== 401) this.loadError = true;
      } finally { if (!this.disposed && request === this.readVersion) this.isBusy = false; }
    },
  },
  mounted() { this.loadData(); },
  beforeDestroy() { this.disposed = true; this.readVersion++; },
};
</script>
